export default {
  init() {
    // JavaScript to be fired on all pages

    // Nav - Scroll
    /* eslint-disable */
    $(function () {
      var header = $(".banner .navbar");
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 200) {
          header.addClass("scroll");
        } else {
          header.removeClass("scroll");
        }
      });
    });

    // Book Now button

    $(function () {
      $(window).scroll(function () {
        var scroll = $(window).scrollTop();

        if (scroll >= 400) {
          $(".btn-booknow").addClass("scroll position-fixed");
        } else {
          $(".btn-booknow").removeClass("scroll position-fixed");
        }
      });
    });

    // Menu

    $(".nav-button").click(function () {
      $("body").toggleClass("nav-open");
      $("body").toggleClass("lock-scroll");
    });

    $(".close_menu").hover(function () {
      $("body").removeClass("nav-open");
      $("body").removeClass("lock-scroll");
    });

    // Search

    $("a.search").click(function () {
      $(".search-popup").toggleClass("active");
      $("body").toggleClass("lock-scroll");
    });

    // Search close

    $("a.search-close").click(function () {
      $(".search-popup").removeClass("active");
      $("body").removeClass("lock-scroll");
    });

    // Slider
    $(".main-slider").slick({
      dots: false,
      infinite: true,
      speed: 400,
      cssEase: "linear",
      autoplay: true,
      autoplaySpeed: 8000,
      fade: true,
      arrows: true,
      // centerMode: true,
      draggable: false,
    });

    // Services Slider
    $(".services_slider").slick({
      dots: false,
      infinite: true,
      speed: 400,
      cssEase: "linear",
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: true,
      centerMode: false,
      autoplay: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    //  News Slider - Inner pages
    /* eslint-disable */
    $(".news-page-carousel ").slick({
      dots: false,
      infinite: false,
      speed: 400,
      cssEase: "linear",
      slidesToShow: 2,
      slidesToScroll: 2,
      arrows: false,
      dots: true,

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });

    // ekko-Lightbox

    /**
     * Prevent default click behavior on WordPress gallery image links
     */
    /* eslint-disable */
    // $(document).on('click', '.blocks-gallery-item a', function(event) {
    //   event.preventDefault();
    //   $(this).ekkoLightbox({
    //     // showArrows: true,
    //     alwaysShowClose: true,
    //     title: '',
    //     footer: '',
    //     // maxWidth: 1280,
    //     // maxHeight: 900,

    //     strings: {

    //         close: 'Close',

    //         fail: 'Failed to load image:',

    //         type: 'Could not detect remote target type. Force the type using data-type',

    //       },

    //   });
    // });

    // Make an ekko lightbox out of WordPress galleries
    $(".blocks-gallery-item a[href]")
      // Test whether this link is directly to an image file
      .filter(function () {
        return /(jpg|gif|png)$/.test($(this).attr("href"));
      })
      .each(function () {
        // Get link attr
        var link = $(this).attr("href");

        // Get the image ALT text
        var alt = $(this).find("img").attr("alt");

        // Strip the file extension
        var filename =
          link.substr(0, $(this).attr("href").lastIndexOf(".")) ||
          $(this).attr("href");

        // Get the index of just the filename without the path
        var fileNameIndex = filename.lastIndexOf("/") + 1;

        // Return just the filename without the path and without the extension
        filename = filename.substr(fileNameIndex);

        // Get the ALT text so we can use it as a caption ONLY if it's NOT the same as the filename!
        // WordPress automatically uses the filename as ALT text if no caption or ALT is set, so we don't want to use it if they're the same.
        var caption = filename === alt ? "" : alt;

        // Get the gallery ID
        var gallery = $(this).closest(".blocks-gallery-item").attr("class");

        // Add ekko lightbox data-attributes
        $(this).attr({
          "data-toggle": "lightbox",
          "data-gallery": gallery,
          "data-footer": caption,
        });
      });

    // Youtube
    // $('#open-youtube').click(function (e) {
    //     e.preventDefault();
    //     $(this).ekkoLightbox();
    // });

    $(document).on("click", '[data-toggle="lightbox"]', function (event) {
      event.preventDefault();
      $(this).ekkoLightbox();
    });

    // Instafeed
    /* eslint-disable */
    var Instafeed = require("instafeed.js");

    var galleryFeed = new Instafeed({
      get: "user",
      userId: 409996162,
      accessToken: "409996162.1677ed0.ded71d9245b1475bb731e928367c6350",
      resolution: "standard_resolution",
      sortBy: "random",
      limit: 6,
      template:
        '<div class="parent"><a href="{{link}}" target="_blank"><div class="img-featured-container" style="background-image:url({{image}})"><div class="img-backdrop d-flex align-items-center justify-content-center"><i class="fa fa-instagram"></i></div></div></a></div>',
      target: "instafeed-gallery-feed",
      after: function () {
        // disable button if no more results to load
        if (!this.hasNext()) {
          btnInstafeedLoad.setAttribute("disabled", "disabled");
        }
      },
    });
    galleryFeed.run();

    // Scroll
    $(".arrow").click(function () {
      // console.log('click');

      if (
        location.pathname.replace(/^\//, "") ==
          this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        // console.log(target);
        if (target.length) {
          // console.log(target+'exists');
          $("html, body").animate(
            {
              scrollTop: target.offset().top - 100,
            },
            600
          );
          return false;
        }
      }
    });
    // Add class on mobile
    $("ul.mobile-menu > li").addClass("column");
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js